import type { JSX } from "react";

export function BrandLogo({
  className = "h-24 w-24",
  loading = false,
}: {
  className?: string;
  loading?: boolean;
}): JSX.Element {
  return (
    <img
      src="/brand/buma-logo.png"
      alt=""
      aria-hidden="true"
      className={`${className} object-contain drop-shadow-sm ${loading ? "motion-safe:animate-pulse" : ""}`}
    />
  );
}
